// Central repository for all query keys
export const queryKeys = {
  partners: {
    all: ['partners'] as const,
    list: () => [...queryKeys.partners.all] as const,
  },
  schedule: {
    all: ['schedule'] as const,
    byDate: (
      fromDate: string,
      toDate: string,
      includeUnpublished: boolean,
      limitedOnly?: boolean
    ) =>
      ['schedule', fromDate, toDate, includeUnpublished, limitedOnly] as const,
    vacationTypes: () => [...queryKeys.schedule.all, 'vacationTypes'] as const,
    vacationRequests: () => [...queryKeys.schedule.all, 'requests'] as const,
    vacationRequestsById: (partnerId: number) =>
      [...queryKeys.schedule.all, 'requests', partnerId] as const,
    publishDate: (year: number, month: number) =>
      [...queryKeys.schedule.all, 'publishDate', { year, month }] as const,
  },
  documents: {
    all: ['documents'] as const,
    list: () => [...queryKeys.documents.all] as const,
    metadata: () => [...queryKeys.documents.all, 'metadata'] as const,
    links: () => [...queryKeys.documents.all, 'links'] as const,
  },
  shifts: {
    all: ['shifts'] as const,
    list: () => [...queryKeys.shifts.all] as const,
    config: () => [...queryKeys.shifts.all, 'config'] as const,
    byDate: (date: Date) => [...queryKeys.shifts.all, date] as const,
  },
  shiftByInterval: {
    all: ['shiftByInterval'] as const,
    list: () => [...queryKeys.shiftByInterval.all] as const,
    slotInterval: (slotId: number, fromDate: Date) =>
      [...queryKeys.shiftByInterval.all, slotId, fromDate] as const,
  },
  reports: {
    all: ['reports'] as const,
    shifts: (year: number) =>
      [...queryKeys.reports.all, 'shifts', year] as const,
    comp: (year?: number) =>
      [...queryKeys.reports.all, 'comp', ...(year ? [{ year }] : [])] as const,
  },
  holidays: {
    all: ['holidays'] as const,
    list: () => [...queryKeys.holidays.all] as const,
    withShifts: (year?: number) =>
      [...queryKeys.holidays.all, 'withShifts', year] as const,
  },
  profile: {
    all: ['profile'] as const,
    data: () => [...queryKeys.profile.all] as const,
  },
  vacationTypes: {
    all: ['vacationTypes'] as const,
    list: () => [...queryKeys.vacationTypes.all] as const,
  },
  users: {
    all: ['users'] as const,
    list: () => [...queryKeys.users.all] as const,
    details: (uid: string) => [...queryKeys.users.all, { uid }] as const,
  },
} as const;

// Type helper for query keys
export type QueryKeys = typeof queryKeys;
